import request from '@/common/request.js'

export function getInviteLaunchUserInfo (data) {
  return request.get('/anonymous/h5/invite/launch/user', { params: data })
}

export function loginMsg (data) {
  return request.post('/anonymous/h5/login/msg', data)
}

export function logout () {
  return request.get('/anonymous/auth/logout')
}

export const uploadUrl = '/api/anonymous/h5/oss/upload'

export function qrcodeScan (data) {
  return request.get('/anonymous/h5/qrcode/scan', { params: data })
}
